import { render, staticRenderFns } from "./wechatQr.vue?vue&type=template&id=0ddf7bc0&scoped=true"
import script from "./wechatQr.vue?vue&type=script&lang=js"
export * from "./wechatQr.vue?vue&type=script&lang=js"
import style0 from "./wechatQr.vue?vue&type=style&index=0&id=0ddf7bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf7bc0",
  null
  
)

export default component.exports